export const enumWar = {
  0: 'Обычная',
  1: 'Гарантия',
  2: 'Возможно гарантия',
};
